<template>
  <div class="loading-overlay active" v-if="visible">
    <button class="close-btn" @click="$emit('close')">×</button>
    <div class="progress-container">
      <el-progress type="circle" :percentage="percentage">
        <p style="font-size: 14px;color: #4ed7ff;">数据加载中...</p>
        <p style="font-size: 16px;color: #4ed7ff;">{{ percentage }}%</p>
      </el-progress>
    </div>
  </div>
</template>

<script setup>
defineProps({
  visible: { type: Boolean, default: false },
  percentage: { type: Number, default: 0 }
});

defineEmits(['close']);
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}

.loading-overlay.active {
  opacity: 0.6;
  visibility: visible;
}

.progress-container {
  width: 90%;
  max-width: 300px;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  transition: transform 0.3s;
}

.close-btn:hover {
  transform: scale(1.2);
}

@media screen and (max-width: 768px) {
  .progress-container {
    max-width: 220px;
  }
}
</style>
